export default __webpack_public_path__ + "static/media/default 2.f8b92898.gif";